module.exports = __webpack_public_path__ + "img/MapThumb_Marshlands.0c3b46d2.webp";